export const ACTION_GET_ICONS = "ACTION_GET_ICONS";